import ServerError from '@/common/utils/errors/ServerError';
import i18n from '@/common/i18n';

export default class AccessDisabledError extends ServerError {
  constructor(response: Response, body?: ErrorBody) {
    super(response, body, i18n.t('Login has been disabled by the administrator'), 'Access disabled');
  }
}
